import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";
import { ExtraContent } from "./dto";

export class ExtraContentAPI extends BaseAPI {
    private year = new Date().getFullYear();

    public getList(courseType: CourseType): Promise<ExtraContent[]> {
        return this.api.get(`/${courseType}/${this.year}/extra-content/?tipo=extras`);
    }
}